import React, { useEffect, useState } from "react";
import "./OrderNew.scss";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { useNavigate } from "react-router-dom";

const OrderNew = () => {
  const navigate = useNavigate();
  useBackButton("/", false, false);

  return (
    <>
      <Header></Header>
      <SubHeader></SubHeader>
      <div className="row order-create">
        <div className="col col-0 cancel col-md-3">
          <div className="return-btn" onClick={() => {navigate('/orders')}}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 20C0 16.2828 0 14.4241 0.307436 12.8786C1.56994 6.53151 6.53151 1.56994 12.8786 0.307436C14.4241 0 16.2828 0 20 0C23.7172 0 25.5759 0 27.1214 0.307436C33.4685 1.56994 38.4301 6.53151 39.6926 12.8786C40 14.4241 40 16.2828 40 20C40 23.7172 40 25.5759 39.6926 27.1214C38.4301 33.4685 33.4685 38.4301 27.1214 39.6926C25.5759 40 23.7172 40 20 40C16.2828 40 14.4241 40 12.8786 39.6926C6.53151 38.4301 1.56994 33.4685 0.307436 27.1214C0 25.5759 0 23.7172 0 20Z"
                fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M23.0893 14.4108C22.7638 14.0854 22.2362 14.0854 21.9108 14.4108L16.9108 19.4108C16.7545 19.5671 16.6667 19.7791 16.6667 20.0001C16.6667 20.2211 16.7545 20.4331 16.9108 20.5893L21.9108 25.5893C22.2362 25.9148 22.7638 25.9148 23.0893 25.5893C23.4147 25.2639 23.4147 24.7363 23.0893 24.4108L18.6785 20.0001L23.0893 15.5893C23.4147 15.2639 23.4147 14.7363 23.0893 14.4108Z"
                fill="#191A21" />
            </svg>
            Назад
          </div>
        </div>
        <div className="col col-12 col-md-9">
          <div className="card">
            <div className="row">
              <div className="col col-12">
                <h2>Создание заказа</h2>
              </div>
              <div className="col col-12">
                <div className="form-floating mb-3">
                  <select className="form-select form-control" id="floatingInputType">
                    <option selected></option>
                    <option value="1">Дизайн интерьера</option>
                    <option value="2">Архитектурный проект</option>
                    <option value="3">Ландшафтный дизайн</option>
                  </select>
                  <label for="floatingInputType">Тип заказа</label>
                </div>
              </div>
              <div className="col col-md-6 col-12">
                <h2>Общая информация</h2>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputName" className="form-control" />
                  <label for="floatingInputName">Название объекта*</label>
                </div>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputName" className="form-control" />
                  <label for="floatingInputName">Адрес объекта*</label>
                </div>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputName" className="form-control" />
                  <label for="floatingInputName">Площадь объекта*</label>
                </div>
              </div>
              <div className="col col-md-6 col-12">
                <h2>Пожелание к проекту</h2>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputPhone" className="form-control" />
                  <label for="floatingInputPhone">Назначение объекта (жилое, офис)</label>
                </div>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputPhone" className="form-control" />
                  <label for="floatingInputPhone">Жилые зоны (спальни, кухни, ванные)</label>
                </div>
                <div className="form-floating mb-3">
                  <textarea type="text" placeholder="" id="floatingInputPhone" className="form-control"></textarea>
                  <label for="floatingInputPhone">Дополнительные требования</label>
                </div>
              </div>
              <div className="col col-md-6 col-12">
                <h2>Приложения</h2>
                <label className="btn-label" for="">План объекта</label>
                <div className="btn btn-white btn-load"><span>Загрузить документ</span></div>
                <label className="btn-label" for="">Фотографии объекта</label>
                <div className="btn btn-white btn-load"><span>Загрузить изображение</span></div>
              </div>
              <div className="col col-md-6 col-12">
                <h2>Приложения</h2>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputPhone" className="form-control" />
                  <label for="floatingInputPhone">Мебель и оборудование</label>
                </div>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputPhone" className="form-control" />
                  <label for="floatingInputPhone">Декоративные элементы</label>
                </div>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputPhone" className="form-control" />
                  <label for="floatingInputPhone">Бюджет</label>
                </div>
                <div className="form-floating mb-3">
                  <input type="text" placeholder="" id="floatingInputPhone" className="form-control" />
                  <label for="floatingInputPhone">Сроки</label>
                </div>
              </div>
              <div className="col col-12">
                <h2>Примеры того что хочется*</h2>
                <div className="btn btn-white btn-load"><span>Загрузить изображение</span></div>
              </div>
              <div className="col col-12 mt-4">
                <div className="btn btn-save">Создать заказ</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderNew;